import info from '../assets/info.png';
export const Imagesdata = (data) => {
  const img = {
    info,
  };

  return img[data];
};
